import React, { useEffect, useMemo, useState } from 'react';
import { DialogComponent } from '../../../../../../Components';
import UsersIcon02 from '../../../../../../assets/icons/UsersIcon02';
import ResultsChart from './ResultsChart';
import './ShareToLeadXchangePool.scss';
import { ButtonBase } from '@material-ui/core';

export default function ShareToLeadXchangePool({
  isOpen,
  onClose,
  LeadsIds,
  failureList = [],
}) {
  const [failureCount, setFailureCount] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const failureItems = useMemo(() => {
    const angryBirdCount = failureList.filter(
      (item) =>
        item.reason.toLowerCase().includes('angry bird') ||
        item.reason.toLowerCase().includes('highprofile')
    ).length;

    const transactionCount = failureList.filter((item) =>
      item.reason.toLowerCase().includes('transaction')
    ).length;

    const dncrCount = failureList.filter((item) =>
      item.reason.toLowerCase().includes('dncr')
    ).length;

    const result = [];

    if (angryBirdCount > 0) {
      result.push({
        count: angryBirdCount,
        message: 'Linked with angry bird contact or HighProfile Contact',
      });
    }

    if (transactionCount > 0) {
      result.push({
        count: transactionCount,
        message: 'Linked to transaction',
      });
    }

    if (dncrCount > 0) {
      result.push({
        count: dncrCount,
        message: 'Blocked in DNCR',
      });
    }

    return result;
  }, [failureList]);

  useEffect(() => {
    if (isOpen) {
      setTotalCount(LeadsIds.length);
      setFailureCount(failureList.length);
      setCorrectCount(LeadsIds.length - failureList.length);
    }
  }, [isOpen, failureList, LeadsIds.length]);

  return (
    <DialogComponent
      isOpen={isOpen}
      dialogTitle={
        <div className='dialog-header-container'>
          <div className='dialog-header-wrapper'>
            <div className='dialog-icon-wrapper'>
              <UsersIcon02
                width='24'
                height='24'
                fill={'#344054'}
                style={{ flexShrink: '0' }}
              />
            </div>
            <div className='dialog-title-wrapper'>
              <h1>LeadXchange share results</h1>
              <span>Here’s a summary of your lead sharing attempt</span>
            </div>
          </div>
          <div className='shared-dialog-divider'></div>
        </div>
      }
      dialogContent={
        <div className='share-dialog-content-wrapper'>
          {correctCount > 0 && (
            <div className='dialog-left-content'>
              <h1 className='mt-3'>Your results</h1>
              <div className='dialog-results-content'>
                <ResultsChart
                  correct={correctCount}
                  total={totalCount}
                />
                <div className='dialog-results-text'>
                  <div className='dialog-results-wrapper'>
                    <img
                      alt='alertIcon'
                      width='38'
                      height='38'
                      src='/images/contacts/successIcon.svg'
                    />
                    <h1>Great!</h1>
                  </div>
                  <span>Leads are now available in the LeadXchange pool</span>
                </div>
              </div>
            </div>
          )}
          {failureList.length > 0 && (
            <div className='dialog-right-content'>
              <h1>Failure details</h1>
              <div className='dialog-failure-content'>
                <div className='failure-header'>
                  <img
                    alt='alertIcon'
                    width='38'
                    height='38'
                    src='/images/contacts/alertIcon.svg'
                  />
                  <div className='failure-text-wrapper'>
                    <div className='failure-count-total'>{failureCount}</div>
                    Failed leads
                  </div>
                </div>

                <div className='dialog-check-items'>
                  {failureItems.map((item, index) => (
                    <div
                      key={`failure-item-${index}`}
                      className='dialog-check-item'
                    >
                      <div className='failure-count'>{item.count}</div>
                      <span className='failure-message'>{item.message}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className='dialog-failure-text'>
                These leads remain in your pipeline. To resolve, review the
                associated contacts or transaction status.
              </div>
            </div>
          )}
        </div>
      }
      maxWidth={'sm'}
      onCancelClicked={onClose}
      dialogActions={
        <>
          <div className='shared-dialog-divider'></div>
          <div className='entity-dialog-actions'>
            <ButtonBase
              className='btns theme-propx outlined mt-3 '
              onClick={onClose}
            >
              Close
            </ButtonBase>
          </div>
        </>
      }
    />
  );
}
